import { FC, ReactNode } from 'react';
import { motion } from 'framer-motion';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center' | 'right';
  className?: string;
  children?: ReactNode;
}

const SectionTitle: FC<SectionTitleProps> = ({
  title,
  subtitle,
  align = 'center',
  className = '',
  children,
}) => {
  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  const dividerAlignClasses = {
    left: 'mx-0',
    center: 'mx-auto',
    right: 'ml-auto',
  };

  return (
    <div className={`${alignClasses[align]} mb-12 ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="section-heading font-serif text-neutral-900">{title}</h2>

        {subtitle && (
          <p className="section-subheading mt-3 max-w-3xl mx-auto text-neutral-600 max-md:text-neutral-400">
            {subtitle}
          </p>
        )}

        <div
          className={`flex items-center justify-center h-0.5 w-16 bg-red-800 max-md:bg-neutral-500 my-6 ${dividerAlignClasses[align]}`}
        />

        {children}
      </motion.div>
    </div>
  );
};

export default SectionTitle;
